export default __webpack_public_path__ + "static/media/app.bb0845ab.svg";